import queryString from "query-string";

const getUrlParam = (location, param) => {
  const params = queryString.parse(location.search);
  return params[param];
};

export default getUrlParam;
